import { Postcode } from '@app/core/models/postcode.model';
import { StandardResponses } from './../models/standard-response.model';
import { SearchProvince } from './../models/search-post.model';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppConfig, APP_CONFIG } from '@app/app-config.module';

import { Observable } from 'rxjs';
import { timeout, retry } from 'rxjs/operators';
import { Postcard, SearchPostcard } from '../models/postcard.model';
import { StandardResponse, StandardResponses2 } from '../models/standard-response.model';


@Injectable({
  providedIn: 'root'
})
export class PostcardService {
  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    private http: HttpClient
  ) {}

  getPostcards(
    url: string,
    criteria: SearchPostcard,
    pageNumber: number,
    pageSize: number
  ): Observable<StandardResponses2<Postcard>> {
    if (url == null || url == "") {
      url = this.config.apiEndpoint;
    }
    return this.http
      .post<StandardResponses2<Postcard>>(`${url}/postcard-api/from-tdh/master-postcard-info/search`, {
        criteria: criteria,
        pageNumber: pageNumber,
        pageSize: pageSize
      })
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }

  changeStatus(
    url: string,
    code: string,
    active: boolean
  ): Observable<StandardResponse<Postcard>> {
    if (url == null || url == "") {
      url = this.config.apiEndpoint;
    }
    return this.http
      .post<StandardResponse<Postcard>>(`${url}/postcard-api/from-tdh/master-postcard-info/set-active`, {
        code: code,
        active: active
      })
      .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }

  getProvince(
    criteria: SearchProvince,
    pageNumber: number,
    pageSize: number
  ): Observable<StandardResponses<Postcode>> {
    return this.http
    .post<StandardResponses<Postcode>>(
      `${this.config.reportApiEndpoint}/print-and-post/search-province`,
      { criteria: criteria, pageNumber: pageNumber, pageSize: pageSize }
    )
    .pipe(retry(this.config.apiRetry), timeout(this.config.apiTimeout));
  }

}
